import { selectIsProviderAdmin, selectProviderState, useAppSelector } from '@ax/redux-store';
import { routerPaths } from '@ax/constants';
import { Navigate, Outlet } from 'react-router-dom';
import SecurityProvider from '@/modules/Security';

const AdminRoute = () => {
  const isAdmin = useAppSelector(selectIsProviderAdmin);
  const providerInitialized = useAppSelector(selectProviderState);

  if (!providerInitialized) {
    return null;
  }

  if (!isAdmin) {
    return (
      <Navigate
        to={routerPaths.notes}
        replace
      />
    );
  }

  return (
    <SecurityProvider>
      <Outlet />
    </SecurityProvider>
  );
};

export default AdminRoute;
